import { render, staticRenderFns } from "./top-newpage copy.vue?vue&type=template&id=abcca512&scoped=true"
import script from "./top-newpage copy.vue?vue&type=script&lang=js"
export * from "./top-newpage copy.vue?vue&type=script&lang=js"
import style0 from "./top-newpage copy.vue?vue&type=style&index=0&id=abcca512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcca512",
  null
  
)

export default component.exports